import { _ROLES_BACK } from "../../utils/constants";
import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import { Table } from "../../components/real/data/Table";
import { _ROUTES } from "../../utils/_routes_constants";

export const DataView = () => {
  return (
    <BaseBudgetInput
      title="Viewing the activity carried out"
      roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
      TableComponent={Table}
      showFiscalDetailsOnFilterSection={false}
      hideTabs={true}
      filters={[
        {
          key: "activity",
          route: _ROUTES.ACTIVITIES,
          defaultValue: "",
          label: "Activity",
          queryParams: {
            active: 1,
          },
        },
        {
          key: "site",
          route: _ROUTES.SITES,
          defaultValue: "",
          label: "Site",
          dependsOn: "activity",
          dependsOnPayloadName: "activityIds[]",
          allowMultiple: true,
          queryParams: {
            active: 1,
          },
          layoutProps: {
            selectWidth: "auto",
            selectMinWidth: "15%",
          },
        },
      ]}
    />
  );
};
